import { Component } from '@angular/core';
import { DatasetOption } from '@dxo/ng-swift-ui';
import { environment } from '@benefitsui/environments/environment';
import { UserContextService } from '../../services/user-context/user-context.service';
import { UserContext } from '../../services/user-context/user-context.types';
import { AuthenticationService } from '@benefitsui/app/services/auth/authentication.service';
import { Router } from '@angular/router';
import { FlagsService } from '@benefitsui/app/services/flags/flags.service';
import { FlatRouteEntry } from '@dxo/ng-swift-ui/lib/components/nav/components/side-nav/side-nav.types';
import { NavigationRouteEntry } from '@dxo/ng-swift-ui/lib/components/nav/components/top-nav/top-nav.component';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { UserRole } from '@benefitsui/app/shared/enums/users';

@Component({
  selector: 'app-nav-portal-page',
  templateUrl: './nav-portal-page.component.html',
  styleUrls: ['./nav-portal-page.component.scss'],
  providers: [UserContextService]
})
export class NavPortalPageComponent {
  //constants
  LogOut = 'Log off';
  ProfileSettings = 'Profile Settings';
  PartnerPortal = 'Partner Portal';
  PartnerPortalUrl = environment.partnerPortalUrl;
  ProfileSettingsUrl = environment.profileSettingsUrl;

  constructor(
    private authService: AuthenticationService,
    private userContextService: UserContextService,
    private router: Router,
    private flagsService: FlagsService
  ) {
    this.hasListBill = this.flagsService.subscribeToFlag('HASLISTBILL');
    this.showBilling = this.flagsService.subscribeToFlag('SHOW_BILLINGS');
    this.showClaim = this.flagsService.subscribeToFlag('SHOW_CLAIMS');
    this.showDocuments = this.flagsService.subscribeToFlag('SHOW_DOCUMENTS');
    this.showEOI = this.flagsService.subscribeToFlag('SHOW_EOI');
    this.showInsured = this.flagsService.subscribeToFlag('SHOW_INSURED');
    this.showScheduleA = this.flagsService.subscribeToFlag('SHOW_SCHEDULEA');

    this.showManageInsured = combineLatest([this.showInsured, this.hasListBill]).pipe(
      map(([showInsured, hasListBill]: [boolean, boolean]) => showInsured && hasListBill)
    );

    this.userContext = this.userContextService.get();
    this.userFullName = this.userContext.currentUserFullName;
    this.userType = this.userContext.symClass;

    this.logoText = 'benefits';
    this.secondaryNavRoutes = [
      {
        path: 'benefits/dashboard',
        text: 'Dashboard',
        visible: true
      },

      {
        path: 'benefits/billing',
        text: 'Billing',
        visible: this.showBilling
      },
      {
        path: 'benefits/employees',
        text: 'Search Employees',
        visible: this.showManageInsured
      },
      {
        path: 'benefits/claims',
        text: 'Claims',
        visible: this.showClaim
      },
      {
        path: 'benefits/report',
        text: 'EOI Report',
        visible: this.showEOI
      },
      {
        path: 'benefits/documents',
        text: 'Contract Documents',
        visible: this.showDocuments
      },
      {
        path: 'benefits/letter',
        text: 'Tax Forms ',
        visible: this.showScheduleA
      }
    ];

    this.accountMenuItemsEmployee = [
      {
        text: this.LogOut,
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];

    this.accountMenuItemsPolicy = [
      {
        text: this.ProfileSettings,
        icon: '',
        onClick: () => this.goProfileSettings()
      },
      {
        text: this.LogOut,
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];

    this.accountMenuItemsBroker = [
      {
        text: this.PartnerPortal,
        icon: '',
        onClick: () => this.goPartnerPortal()
      },
      {
        text: this.ProfileSettings,
        icon: '',
        onClick: () => this.goProfileSettings()
      },
      {
        text: this.LogOut,
        icon: 'lock',
        onClick: () => this.logout()
      }
    ];

    this.secondaryNavRoutesTranslated = this.secondaryNavRoutes.map(this.navRouteEntryToFlatRouteEntry);

    switch (this.userType.toLowerCase()) {
      case UserRole.Employee:
        this.accountMenuItems = this.accountMenuItemsEmployee;
        break;
      case UserRole.Broker:
        this.accountMenuItems = this.accountMenuItemsBroker;
        break;
      case UserRole.Sponsor:
        this.accountMenuItems = this.accountMenuItemsPolicy;
        break;
      default:
        this.accountMenuItems = this.accountMenuItemsEmployee;
        break;
    }
  }

  // :  Data members
  hasListBill = new BehaviorSubject<boolean>(false);
  showBilling = new BehaviorSubject<boolean>(false);
  showClaim = new BehaviorSubject<boolean>(false);
  showDocuments = new BehaviorSubject<boolean>(false);
  showEOI = new BehaviorSubject<boolean>(false);
  showInsured = new BehaviorSubject<boolean>(false);
  showScheduleA = new BehaviorSubject<boolean>(false);
  showManageInsured: Observable<boolean>;

  accountMenuItems: FlatRouteEntry[] = [];
  accountMenuItemsPolicy: FlatRouteEntry[] = [];
  accountMenuItemsBroker: FlatRouteEntry[] = [];
  accountMenuItemsEmployee: FlatRouteEntry[] = [];
  logoText: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  secondaryNavRoutes: any[] = [];
  // secondaryNavRoutes: NavigationRouteEntry[] = [];
  secondaryNavRoutesTranslated: FlatRouteEntry[] = [];

  userContext: UserContext;
  userFullName: string;
  userType: string;

  initialCountdown: number = environment.countdownSeconds;

  logoutDatasetData: DatasetOption['data'] = {
    name: 'Logout'
  };
  logoutDataset: DatasetOption[] = [
    { data: this.logoutDatasetData },
    { selector: 'span,div,dxo-icon', data: this.logoutDatasetData }
  ];

  logout() {
    this.authService.logout();
  }

  goProfileSettings() {
    window.open(this.ProfileSettingsUrl);
  }

  goPartnerPortal() {
    window.location.href = this.PartnerPortalUrl;
  }

  openDocument = () => console.log('Upload Documents');

  private navRouteEntryToFlatRouteEntry(route: NavigationRouteEntry): FlatRouteEntry {
    const visible = route.visible as boolean;

    const flatRoute: FlatRouteEntry = {
      path: route.path,
      params: route.params,
      text: route.text,
      visible: visible
    };

    return flatRoute;
  }
}
